export default "__VITE_ASSET__$dn9Pec5__"